export default __webpack_public_path__ + "static/media/cubbo_box.a0947e43.png";